import React from 'react';
import BaseModal from 'shared-components/BaseModal/Modal';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import classes from './CampaignModal.module.css';

const CampaignModal = ({
  setConfirmModalOpen,
  confirmModalOpen,
  setCreateCampaignOpen,
}) => {
  return (
    <BaseModal
      isOpen={confirmModalOpen}
      showCloseIcon
      onRequestClose={() => setConfirmModalOpen(false)}
      className="campaign-page"
    >
      <div className={classes.container}>
        <button
          className={classes.closeButton}
          type="button"
          onClick={() => setConfirmModalOpen(false)}
        >
          <i className="fas fa-times-circle" />
        </button>
        <div className={classes.textContainer}>
          <h1 className={classes.title}>Are you sure?</h1>
          <p className={classes.warning}>You have unsaved changes.</p>
          <p className={classes.text}>
            If you create a new campaign you will lose any unsaved changes to
            the current campaign.
          </p>
        </div>

        <div className={classes.buttonContainer}>
          <Button
            className={classes.modalButton}
            type="button"
            onClick={() => setCreateCampaignOpen(true)}
            buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
          >
            Yes, continue
          </Button>
          <Button
            className={classes.modalButton}
            type="button"
            onClick={() => setConfirmModalOpen(false)}
            buttonType={BUTTON_TYPES.TERTIARY}
          >
            Cancel
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default CampaignModal;
